export enum SubjectEntity {
    USER = 'user',
    ORG = 'org',
    DOMAIN = 'domain',
    DOMAIN_INTEGRATION = 'domain_integration',
    FEED = 'feed',
    CATEGORY_STRATEGY = 'category_strategy',
}
